import { forwardRef } from 'react';
import { cn } from '@/lib/utils/cn';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'elevated' | 'highlighted' | 'ghost';
  padding?: 'none' | 'sm' | 'md' | 'lg';
  as?: 'div' | 'article' | 'section' | 'li';
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ variant = 'default', padding = 'md', as: Tag = 'div', className, children, ...props }, ref) => {
    const TagEl = Tag as any;
    return (
      <TagEl
        ref={ref as any}
        className={cn(
          'rounded-[var(--radius-lg)] border',
          // Variants
          variant === 'default'     && 'bg-[var(--color-bg-secondary)] border-[var(--color-border)]',
          variant === 'elevated'    && 'bg-[var(--color-bg-secondary)] border-[var(--color-border)] card-shadow',
          variant === 'highlighted' && 'bg-[color-mix(in_srgb,var(--color-accent-primary)_8%,var(--color-bg-secondary))] border-[color-mix(in_srgb,var(--color-accent-primary)_30%,var(--color-border))]',
          variant === 'ghost'       && 'bg-transparent border-transparent',
          // Padding
          padding === 'none' && 'p-0',
          padding === 'sm'   && 'p-3',
          padding === 'md'   && 'p-5',
          padding === 'lg'   && 'p-7',
          className,
        )}
        {...props}
      >
        {children}
      </TagEl>
    );
  }
);
Card.displayName = 'Card';
